import { StarIcon, HeartIcon } from "@heroicons/react/24/outline";
import { StarIcon as StarIconSolid } from "@heroicons/react/24/solid";
import Flag from "./assets/flag.svg";
import { useNavigate } from "react-router-dom";

const ProductsList = ({ productCatalog }: any) => {
  const navigate = useNavigate();

  const handleProductClick = (productId: number) => {
    // Navigate to the product without using window.location.href
    navigate(`/product-catalog/${productId}/start-designing`);
  };

  // Check if productCatalog is an array and has items
  if (!Array.isArray(productCatalog) || productCatalog.length === 0) {
    return <div className="text-center py-8 text-gray-500">No products found</div>;
  }

  return (
    <div className="flex flex-wrap items-stretch justify-start">
      {productCatalog.map((product: any) => (
        <div key={product.CustomizedProductID || `product-${Math.random()}`} className="w-1/3 max-xl:w-1/2 max-md:w-full p-2">
          <div className="relative bg-white rounded-md p-2 h-full flex flex-col">
            <button className="absolute top-3 right-3 bg-white shadow border border-gray-100 rounded-full w-6 h-6 flex items-center justify-center hover:bg-gray-100">
              <HeartIcon className="h-4 w-4 text-gray-500" />
            </button>
            <div className="flex justify-center">
              <button onClick={() => handleProductClick(product.CustomizedProductID)} className="w-full">
                <img src={product.productImage} alt={product.title} className="max-w-full h-auto" />
              </button>
            </div>
            <div className="my-1 text-[16px] font-bold">
              <button onClick={() => handleProductClick(product.CustomizedProductID)} className="text-left hover:text-primaryred">
                {product.title}
              </button>
            </div>
            <div className="mb-2 flex items-center gap-2">
              <div className="flex">
                <StarIconSolid className="h-3 w-3 text-[#F7B501]" />
                <StarIconSolid className="h-3 w-3 text-[#F7B501]" />
                <StarIconSolid className="h-3 w-3 text-[#F7B501]" />
                <StarIconSolid className="h-3 w-3 text-[#F7B501]" />
                <StarIcon className="h-3 w-3 text-[#F7B501]" />
              </div>
            </div>
            <div className="flex flex-wrap gap-1">
              {product.CustomizedProductVariants?.map((variant: any) => (
                <div
                  key={variant.id}
                  className="w-3 h-3 rounded-full"
                  style={{ backgroundColor: variant.title.toLowerCase() }}
                ></div>
              ))}
            </div>
            <div className="mt-auto">
              <div className="my-1 text-[16px] font-bold">
                ${product.CustomizedProductVariants?.[0]?.price || '0.00'}
              </div>
              {product.shipping_method_details && (
                <div className="flex items-center gap-1.5 my-1 text-xs">
                  <img className="inline rounded-sm" src={Flag} width={25} alt="" />
                  <div>
                    Estimated delivery {product.shipping_method_details.shipDayMin}-{product.shipping_method_details.shipDayMax} days
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default ProductsList;
